import { z } from 'zod';

export const auditLogsFilterSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('all') }),
  z.object({ mode: z.literal('user'), userId: z.string() }),
  z.object({ mode: z.literal('entity-type'), entityType: z.string() }),
  z.object({
    mode: z.literal('entity'),
    entityType: z.string(),
    entityId: z.string(),
  }),
]);

export type AuditLogsFilter = z.infer<typeof auditLogsFilterSchema>;
export type AuditLogsFilterMode = AuditLogsFilter['mode'];

export const isAuditLogsFilterReady = (filter: AuditLogsFilter): boolean => {
  switch (filter.mode) {
    case 'all':
      return true;
    case 'user':
      return filter.userId.length > 0;
    case 'entity-type':
      return filter.entityType.length > 0;
    case 'entity':
      return filter.entityType.length > 0 && filter.entityId.length > 0;
  }
};

export type AuditApiQuery =
  | { filter: 'organization' }
  | { filter: 'user'; userId: string }
  | { filter: 'entity-type'; entityType: string }
  | { filter: 'entity'; entityType: string; entityId: string };

export const toAuditApiQuery = (filter: AuditLogsFilter): AuditApiQuery => {
  switch (filter.mode) {
    case 'all':
      return { filter: 'organization' };
    case 'user':
      return { filter: 'user', userId: filter.userId };
    case 'entity-type':
      return { filter: 'entity-type', entityType: filter.entityType };
    case 'entity':
      return { filter: 'entity', entityType: filter.entityType, entityId: filter.entityId };
    default: {
      const _exhaustive: never = filter;
      return _exhaustive;
    }
  }
};
